import { useCallback, useRef } from 'react';

/**
 * Guards against out-of-order async responses when a fetch can be re-triggered before the
 * previous one resolves (polling, rapid re-fetch on prop change, etc.). Call `startRequest()`
 * right before firing the request and stash the returned token; inside the response handler,
 * check `isCurrent(token)` before applying any state — a superseded (stale) response must be
 * dropped, never allowed to overwrite state set by a request that started later.
 */
export function useLatestRequestGuard() {
    const tokenRef = useRef(0);

    const startRequest = useCallback(() => {
        tokenRef.current += 1;
        return tokenRef.current;
    }, []);

    const isCurrent = useCallback((token: number) => token === tokenRef.current, []);

    return { startRequest, isCurrent };
}
